import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "spinner"
}
const _hoisted_2 = {
  key: 1,
  class: "admin-page-wr"
}
const _hoisted_3 = { class: "dashboard-header" }
const _hoisted_4 = { class: "subtitle-main" }
const _hoisted_5 = { class: "filters" }
const _hoisted_6 = {
  class: "dropdown-button input-dropdown",
  type: "button"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "table-default" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($setup.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[2] || (_cache[2] = _createElementVNode("h2", { class: "title-main" }, "Saved Packages", -1)),
            _createElementVNode("h3", _hoisted_4, _toDisplayString($setup.plural($setup.packages.length, "Package")), 1),
            _createElementVNode("div", _hoisted_5, [
              _createVNode($setup["DropDown"], { class: "dropdown-container" }, {
                control: _withCtx(() => [
                  _createElementVNode("label", _hoisted_6, _toDisplayString($setup.estateSelected), 1)
                ]),
                dropdown: _withCtx(() => [
                  _createElementVNode("ul", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.optionsEstate, (optionSelected) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: optionSelected.id,
                        onClick: ($event: any) => ($setup.onSelectEstate(optionSelected.title, optionSelected.id)),
                        class: _normalizeClass({ 'dropdown__item-active': optionSelected.title === $setup.estateSelected })
                      }, _toDisplayString(optionSelected.title), 11, _hoisted_7))
                    }), 128))
                  ])
                ]),
                _: 1
              }),
              _createElementVNode("button", {
                class: "button default primary add-btn-primary",
                onClick: $setup.toCreatePackage
              }, "Create Package")
            ]),
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "table-wrapper" }, null, -1)),
            _createElementVNode("table", _hoisted_8, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.tableHeaders, (header) => {
                    return _createElementVNode("th", { key: header }, _toDisplayString(header), 1)
                  }), 64))
                ])
              ]),
              ($setup.packages.length > 0)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_9, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.packages, (savedPackage) => {
                      return (_openBlock(), _createBlock($setup["PackageRow"], {
                        key: savedPackage._id,
                        savedPackage: savedPackage,
                        isDetailsPackageOpen: $setup.isDetailsPackageOpen,
                        getEstateTitle: $setup.getEstateTitle,
                        getLandSize: $setup.getLandSize,
                        getBuildSize: $setup.getBuildSize,
                        formatPrice: $setup.formatPrice,
                        getBedroomCount: $setup.getBedroomCount,
                        getBathroomCount: $setup.getBathroomCount,
                        getLoungeRoomCount: $setup.getLoungeRoomCount,
                        getLotClass: $setup.getLotClass,
                        getLotStatus: $setup.getLotStatus,
                        onDeletePackage: $setup.onDeletePackage,
                        onClickPackage: $setup.onClickPackage,
                        onCopyLink: $setup.onCopyLinkPackage,
                        openDetailsPackage: $setup.openDetailsPackage,
                        isDisplayDetailsEffect: $setup.isDisplayDetailsEffect
                      }, null, 8, ["savedPackage", "isDetailsPackageOpen", "formatPrice", "isDisplayDetailsEffect"]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("tbody", _hoisted_10, [...(_cache[1] || (_cache[1] = [
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", {
                        class: "colspan-headers no-data",
                        colspan: "9"
                      }, "No packages available")
                    ], -1)
                  ]))]))
            ])
          ])
        ])),
    _createVNode($setup["ConfirmDeleteModalVue"], {
      isOpen: $setup.isConfirmDeletePackageModalOpen,
      onConfirm: $setup.onConfirmDeletePackage,
      onClose: _cache[0] || (_cache[0] = ($event: any) => ($setup.isConfirmDeletePackageModalOpen = false))
    }, null, 8, ["isOpen"])
  ], 64))
}